import React from "react";
import {useTranslation} from "react-i18next";
import {THEME} from "@/enums/profile";
import {Chart, MessageContentPieChart} from "@/services/wingman";
import AskBarChart from "./AskBarChart";
import AskPieChart from "./AskPieChart";

export type ChartData = {
   type: "pie" | "bar" | "loading";
   data: MessageContentPieChart["chart"] | Chart;
};

const ChartContent: React.FC<{
   chartData: ChartData;
   themeOverride?: THEME;
   brandOverride?: string;
}> = ({chartData, themeOverride, brandOverride}) => {
   const {t} = useTranslation("ask");

   if (chartData.type === "loading") {
      return (
         <div className="flex items-center justify-center p-8 bg-gray-50 rounded-lg">
            <div className="flex flex-col items-center space-y-2">
               <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500" />
               <span className="text-sm text-gray-600">{t("generatingChart")}</span>
            </div>
         </div>
      );
   }

   if (chartData.type === "pie") {
      return (
         <AskPieChart
            chartData={chartData.data as MessageContentPieChart["chart"]}
            themeOverride={themeOverride}
            brandOverride={brandOverride}
         />
      );
   }

   return (
      <AskBarChart
         chartData={chartData.data as Chart}
         themeOverride={themeOverride}
         brandOverride={brandOverride}
      />
   );
};

export default ChartContent;
